var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{attrs:{"vs-w":"12"}},[_c('Filters',{attrs:{"selected":_vm.selected,"page":`average-treatment-by-gender-and-age-${_vm.type}`},on:{"updateFilters":function($event){_vm.selected = $event}}}),_c('vs-col',{attrs:{"vs-w":"12"}},[_c('BarChart',{attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"height":150}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }